import { Avatar } from "@mui/material";
import { FMSThemeContext } from "contexts/FMSThemeContext";
import React, { useContext } from "react";
import styles from "./ScrollableList.module.css";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { EventCategoryType } from "types/Event";

interface IProps {
  header: string;
  data: string[];
  onAdd: (eventCategoryType: EventCategoryType) => void;
  onDelete: (value: string, eventCategoryType: EventCategoryType) => void;
  eventCategoryType: EventCategoryType;
}

const ScorllableList: React.FC<IProps> = (props) => {
  const { data, header, onAdd, onDelete, eventCategoryType } = props;
  const { primaryColor } = useContext(FMSThemeContext);

  const sortedData = data.sort((a, b) => {
    if (a.toLowerCase() > b.toLowerCase()) {
      return 1;
    }

    if (a.toLowerCase() < b.toLowerCase()) {
      return -1;
    }

    return 0;
  });
  return (
    <>
      <div className={styles.scrollableList}>
        <div className={styles.header}>
          <div className={styles.headerText}>{header}</div>
          <div
            className={styles.addEntry}
            onClick={() => {
              onAdd(eventCategoryType);
            }}
          >
            <Avatar
              style={{
                backgroundColor: primaryColor,
                position: "absolute",
                bottom: "35px",
                right: "20px",
                fontSize: "30px",
                fontWeight: "bold",
                width: 48,
                height: 48,
              }}
            >
              +
            </Avatar>
          </div>
        </div>
        <div className={styles.list}>
          {sortedData.map((value) => {
            return (
              <div className={styles.listItem}>
                <div className={styles.listItemText}>{value}</div>
                <span
                  className={styles.deleteIcon}
                  onClick={() => {
                    onDelete(value, eventCategoryType);
                  }}
                >
                  <DeleteOutlineIcon />
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default ScorllableList;
